import { AuthenticatorProps } from '@aws-amplify/ui-react';

type FormFields = Required<AuthenticatorProps>['formFields'];
type ValueType<T> = T extends { [key: string]: infer T } ? T : unknown;
type FieldGroup = ValueType<FormFields>;
type ReactFormFieldOptions = ValueType<FieldGroup>;

const fields = {
    username: {
        label: 'メールアドレス *',
        labelHidden: false,
        placeholder: 'メールアドレスを入力',
        isRequired: true,
    },
    password: {
        label: 'パスワード *',
        labelHidden: false,
        placeholder: 'パスワードを入力',
        isRequired: true,
    },
    confirmation_code: {
        label: '認証コード *',
        labelHidden: false,
        placeholder: '認証コードを入力',
        isRequired: true,
    },
    new_password: {
        label: '新しいパスワード',
        labelHidden: false,
        placeholder: '新しいパスワードを入力してください',
        isRequired: true,
    },
    confirm_password: {
        label: 'パスワードを認証する',
        labelHidden: false,
        placeholder: '新しいパスワードをもう一度入力してください',
        isRequired: true,
    },
    phone_number: {
        label: '電話番号(SMSを受信可能な番号)',
        labelHidden: false,
        placeholder: '先頭の0を除いた電話番号を入力してください',
        isRequired: true,
        dialCode: '+81',
    },
    family_name: {
        label: '姓',
        labelHidden: false,
        placeholder: '姓を入力してください',
        isRequired: true,
    },
    given_name: {
        label: '名',
        labelHidden: false,
        placeholder: '名を入力してください',
        isRequired: true,
    },
} satisfies { [key: string]: ReactFormFieldOptions };

const confirmResetPassword = {
    password: fields.new_password,
    confirmation_code: fields.confirmation_code,
    confirm_password: fields.confirm_password,
} satisfies FieldGroup;

export const AuthenticatorFormFields: FormFields = {
    signIn: {
        username: fields.username,
        password: fields.password,
    },
    confirmSignIn: {
        confirmation_code: fields.confirmation_code,
    },
    forgotPassword: {
        username: fields.username,
    },
    confirmResetPassword,
    forceNewPassword: {
        password: fields.new_password,
        confirm_password: fields.confirm_password,
        phone_number: fields.phone_number,
        family_name: fields.family_name,
        given_name: fields.given_name,
    },
};
